import './popupMessage.css';
import React, { Component } from 'react';
import Fade from 'animations/Fade';
import TypewriterEffect from 'animations/TypewriterEffect';
import { stylizeKeyword } from 'others/keywords/keywordstyles';

export var popupMessageRef = React.createRef();

class PopupMessage extends Component {
    typewriterRef = React.createRef();
    timeout = null;

    constructor(props) {
        super(props);
        this.state = {
            toggle: false
        };
    }

    componentDidUpdate(prevProps, prevStates, snapshot){
        if(!prevStates.toggle && this.state.toggle){
            this.timeout = setTimeout(()=>{
                clearInterval(this.timeout)
                this.setToggle(false);
            }, this.props.duration);

        }
    }

    setToggle(value){
        this.setState({
            toggle: value
        });
    }

    setMsg(msg){
        this.setState({
            toggle: true
        });
        this.typewriterRef.current.animText(stylizeKeyword(msg));
    }

    render() {
        return(
            <Fade toggle={this.state.toggle}>
                <div id='pm_container'>
                    <TypewriterEffect 
                        ref={this.typewriterRef}
                        textProps={{ id: 'pm_msgText' }}
                    />
                </div>
            </Fade>
        )
    }
}


export default PopupMessage;